import moment from "moment";

export const renderDate = (date: string | undefined | null) => {
  if (date === "0000-00-00 00:00:00" || !date) {
    return "-";
  }

  return moment(date).format("DD MMM YYYY");
};
